import axios from "axios";
import { url } from "./url";

var header = localStorage.getItem('viToken') ? { 'x-access-token': localStorage.getItem('viToken') } : { "user-type": "appUser" };
header['company-code'] = 'VI';
header['country'] = '611e04284ac17121fd8b1a54';
header['platform'] = 'web'
header['language'] = 'EN'

header['Access-Control-Allow-Origin'] = '*'
header['Content-Type'] = 'application/json'
header['Accept'] = 'application/json'
header['X-Frame-Options'] = "SAMEORIGIN"
header['Strict-Transport-Security'] = "max-age=31536000; includeSubDomains"
header["Content-Security-Policy"] = "frame-ancestors 'none'";

// new security headers
header['Referrer-Policy'] = 'strict-origin-when-cross-origin';
header['Permissions-Policy'] = 'geolocation=(), microphone=(), camera=()';
header['X-XSS-Protection'] = '1; mode=block';
header['Cross-Origin-Embedder-Policy'] = 'require-corp';
header['Cross-Origin-Opener-Policy'] = 'same-origin';
header['Cross-Origin-Resource-Policy'] = 'same-origin';


const instance = axios.create({
    baseURL: url.BASE_API_URL,
    timeout: 40000,
    headers: header
});

instance.interceptors.request.use(function (config) {
    if (!!config.data) {
        for (let key of Object.keys(config?.data)) {
            if (config.data[key] === "")
                config.data[key] = null
        }
    }
    return config;
}, function (error) {
    return error //Promise.reject(error);
});

// Add a response interceptor
instance.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    if (response.status === 200) {
        return response.data;
    }
    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error.response?.statusText === "Unauthorized") {
        localStorage.clear();
        //  window.location.href = '/sign-in';
    }
    return error?.response;
});

export default instance;
